<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="'店铺名称'" prop="shopName">
                <a-input v-model="queryParam.shopName" :placeholder="'请输入店铺名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="'用户名称'" prop="userName">
                <a-input v-model="queryParam.userName" :placeholder="'请输入用户名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="'记录类型'" prop="recordType">
                <a-select v-model="queryParam.recordType" :placeholder="'请选择记录类型'" allow-clear>
                  <a-select-option :value="1">{{ '缴纳保证金' }}</a-select-option>
                  <a-select-option :value="2">{{ '退还保证金' }}</a-select-option>
                  <a-select-option :value="3">{{ '售后扣除' }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="'审核状态'" prop="auditStatus">
                <a-select v-model="queryParam.auditStatus" :placeholder="'请选择审核状态'" allow-clear>
                  <a-select-option :value="1">{{ '待审核' }}</a-select-option>
                  <a-select-option :value="2">{{ '审核通过' }}</a-select-option>
                  <a-select-option :value="3">{{ '审核拒绝' }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="'创建时间'" prop="createTime">
                <a-range-picker
                  v-model="createTimeRange"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onCreateTimeChange"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 16" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />
                  {{ '查询' }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />
                  {{ '重置' }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />
          {{ '删除' }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 详情对话框 -->
      <detail-dialog ref="detailDialog" />
      <!-- 审核表单 -->
      <audit-form ref="auditForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1500 }"
      >
        <span slot="amount" slot-scope="text, record">
          <span :style="{ color: record.recordType === 1 ? 'green' : 'red' }">
            {{ text }}
          </span>
        </span>
        <span slot="recordType" slot-scope="text">
          {{ getRecordTypeName(text) }}
        </span>
        <span slot="auditStatus" slot-scope="text">
          <a-tag v-if="text === 1" color="orange">{{ '待审核' }}</a-tag>
          <a-tag v-else-if="text === 2" color="green">{{ '审核通过' }}</a-tag>
          <a-tag v-else color="red">{{ '审核拒绝' }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ formatDate(text) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" >
            <a-icon type="eye" />
            {{ '详情' }}
          </a>
          <a-divider type="vertical" v-if="record.auditStatus === 1"  />
          <a @click="handleAudit(record)" v-if="record.auditStatus === 1" >
            <a-icon type="audit" />
            {{ '审核' }}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">
            <a-icon type="delete" />
            {{ '删除' }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageShopDepositRecord,
  delShopDepositRecord
} from '@/api/shop/shopDepositRecord'
import DetailDialog from './DetailDialog'
import AuditForm from './AuditForm'

export default {
  name: 'ShopDepositRecord',
  components: {
    DetailDialog,
    AuditForm
  },
  data() {
    return {
      // 列表数据
      list: [],
      total: 0,
      loading: false,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        shopName: undefined,
        userName: undefined,
        recordType: undefined,
        auditStatus: undefined,
        beginTime: undefined,
        endTime: undefined
      },
      createTimeRange: [],
      // 表格设置
      tableSize: 'default',
      tableBordered: false,
      advanced: false,
      pageSizeOptions: ['10', '20', '30', '50', '100'],
      // 列设置
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          width: 80
        },
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: '记录类型',
          dataIndex: 'recordType',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'recordType' }
        },
        {
          title: '金额',
          dataIndex: 'amount',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '最高日提现额度',
          dataIndex: 'dailyWithdrawLimit',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'auditStatus' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          ellipsis: true,
          align: 'center',
          fixed: 'right',
          width: 220,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      // 选中行
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      single: true,
      multiple: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询列表 */
    getList() {
      this.loading = true
      pageShopDepositRecord(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询按钮 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        shopName: undefined,
        userName: undefined,
        recordType: undefined,
        auditStatus: undefined,
        beginTime: undefined,
        endTime: undefined
      }
      this.createTimeRange = []
      this.handleQuery()
    },
    /** 创建时间范围选择 */
    onCreateTimeChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.queryParam.beginTime = dateStrings[0]
        this.queryParam.endTime = dateStrings[1]
      } else {
        this.queryParam.beginTime = undefined
        this.queryParam.endTime = undefined
      }
    },
    /** 表格排序变化 */
    handleSortChange(pagination, filters, sorter) {
      if (sorter.column) {
        this.queryParam.orderByColumn = sorter.field
        this.queryParam.isAsc = sorter.order === 'ascend' ? 1 : 0
        this.getList()
      }
    },
    /** 表格选中变化 */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 详情按钮 */
    handleDetail(row) {
      this.$refs.detailDialog.open(row.id)
    },
    /** 审核按钮 */
    handleAudit(row) {
      this.$refs.auditForm.open(row)
    },
    /** 删除按钮 */
    handleDelete(row) {
      const ids = row.id ? [row.id] : this.ids
      const that = this
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据',
        onOk() {
          delShopDepositRecord(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功')
          })
        }
      })
    },
    /** 分页 */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 获取记录类型名称 */
    getRecordTypeName(type) {
      const typeMap = {
        1: '缴纳保证金',
        2: '退还保证金',
        3: '售后扣除'
      }
      return typeMap[type] || '未知'
    },
    formatDate(time) {
      return this.parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    getTotal(total) {
      return '共 ' + total + ' 条'
    }
  }
}
</script>

<style scoped>
</style>
